import { render, staticRenderFns } from "./TaskRating.vue?vue&type=template&id=4c62426e&scoped=true&"
import script from "./TaskRating.vue?vue&type=script&lang=js&"
export * from "./TaskRating.vue?vue&type=script&lang=js&"
import style0 from "./TaskRating.vue?vue&type=style&index=0&id=4c62426e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c62426e",
  null
  
)

export default component.exports